// node_modules
import { FC, MouseEvent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
// Types
import { TTechnology, TTechnologyVotesDTO } from "Types";
// styles
import styles from './technologyVote.module.scss';
// Enums
import { TechnologyVoteTypeEnum, ToastTypeEnum } from "Enums";
// Controllers
import { TechnologyControllerSingleton } from "Controllers";
// Helpers
import { ToastHelperSingleton } from "Helpers";

type TTechnologyVoteProps = {
    technology: TTechnology,
    additionalClassName? : string
}

export const TechnologyVote: FC<TTechnologyVoteProps> = ({technology, additionalClassName}: TTechnologyVoteProps) => {
    const getUserTechnologyVoteIconClassByVote = (vote: TechnologyVoteTypeEnum): string => {
        let iconClass;
        switch (vote) {
            case TechnologyVoteTypeEnum.No:
                iconClass = styles.fontAwesomeSelectedTimesItem;
                break;
            case TechnologyVoteTypeEnum.Yes:
                iconClass = styles.fontAwesomeSelectedCheckItem;
                break;
            case TechnologyVoteTypeEnum.Super:
                iconClass = styles.fontAwesomeSelectedHeartItem;
                break;
            default:
                iconClass = styles.fontAwesomeItem;
                break;
        }

        return iconClass;
    };

    const getCurrentUserTechnologyVoteIconClassByTechnologyVotes = (technologyVotes: TTechnologyVotesDTO | undefined, vote: TechnologyVoteTypeEnum): string => {
        const iconClass = styles.fontAwesomeItem;
        if (!technologyVotes || (technologyVotes && !technologyVotes.currentUserVote)) {
            return iconClass;
        }

        if (technologyVotes && 
        technologyVotes.currentUserVote && 
        technologyVotes.currentUserVote.vote === vote) {
            return getUserTechnologyVoteIconClassByVote(technologyVotes.currentUserVote.vote);
        }

        return iconClass;
    };

    const doVote = async (mouseEvent: MouseEvent<SVGSVGElement>, vote: TechnologyVoteTypeEnum): Promise<void> => {
        mouseEvent.stopPropagation();
        mouseEvent.preventDefault();
        // call server to add user technology vote in the DB
        const isSuccess: boolean = await TechnologyControllerSingleton.voteAsync(technology.id, vote);

        if (!isSuccess) {
            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Was not able to vote on technology.");
            return;
        }
    };

    return (
        <div id="technology-vote-yesnosuper" className={additionalClassName}>
            <FontAwesomeIcon 
                icon={faTimes} 
                className={getCurrentUserTechnologyVoteIconClassByTechnologyVotes(technology.votes, TechnologyVoteTypeEnum.No)} 
                onClick={(mouseEvent) => doVote(mouseEvent, TechnologyVoteTypeEnum.No)} />
            <FontAwesomeIcon 
                icon={faCheck} 
                className={getCurrentUserTechnologyVoteIconClassByTechnologyVotes(technology.votes, TechnologyVoteTypeEnum.Yes)}
                onClick={(mouseEvent) => doVote(mouseEvent, TechnologyVoteTypeEnum.Yes)} />
            <FontAwesomeIcon 
                icon={faHeart} 
                className={getCurrentUserTechnologyVoteIconClassByTechnologyVotes(technology.votes, TechnologyVoteTypeEnum.Super)}
                onClick={(mouseEvent) => doVote(mouseEvent, TechnologyVoteTypeEnum.Super)} />
        </div>
    );
};